/*
 * Copyright (c) 2025 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { ShipmentVehicleDtoModel } from './shipment-vehicle-dto.model';
import { ShipmentDriverDtoModel } from './shipment-driver-dto.model';
import { ShipmentShortVoModel } from './shipment-short-vo.model';
import { ShipmentState } from './shipment-state';

export class ShipmentWithRoutingInfoDto extends JSONable {
  uuid = '';
  owner = '';
  shipmentBaseUuid = '';
  shipmentShortVO: ShipmentShortVoModel = new ShipmentShortVoModel();
  shipmentVehicleDTO: ShipmentVehicleDtoModel = new ShipmentVehicleDtoModel();
  shipmentDriverDTO: ShipmentDriverDtoModel = new ShipmentDriverDtoModel();
  shipmentState: ShipmentState = new ShipmentState();
}
